export const loadInbioContents = (campaignId) => {
  return (dispatch) => {
    dispatch({ type: "LOAD_INBIO_CONTENTS_REQUEST" });
    fetch(`/api/v1/inbio/pages/${campaignId}`, { credentials: "same-origin" })
      .then((res) => res.json())
      .then((data) => dispatch({ type: "LOAD_INBIO_CONTENTS_SUCCESS", data }))
      .catch((err) => dispatch({ type: "LOAD_INBIO_CONTENTS_FAILURE", err }));
  };
};
